import React, { PropTypes } from 'react';
import { ListGroup, ListGroupItem } from 'react-bootstrap';

class ShopSubCategoryList extends React.Component {
   render() {
      const { subCategories, shopId, categoryId, addSubCategory } = this.props;
      return (
         <ListGroup>
            {subCategories.map((subCategory) => (
               <ListGroupItem key={subCategory.id} >
                  <span className="add-button"
                        onClick={() => addSubCategory(shopId, categoryId, subCategory.id)} >add {" "}</span>
                  {subCategory.name}
               </ListGroupItem>
            ))}
         </ListGroup>
      );
   }
}

ShopSubCategoryList.propTypes = {
   subCategories: PropTypes.array.isRequired,
   shopId: PropTypes.number,
   categoryId: PropTypes.number,
   addSubCategory: PropTypes.func,
};
export default ShopSubCategoryList;



/** WEBPACK FOOTER **
 ** ./src/components/ItemManagement/Product/ProductMain/ProductMainEdit/ProductMainLocation/ShopSubCategoryList.js
 **/